import React from 'react';

export const GitlabSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="32" fill="#F5F5F5" />
			<rect width="32" height="32" rx="8" fill="white" />
			<rect
				x="0.508324"
				y="0.508324"
				width="30.9834"
				height="30.9834"
				rx="7.49168"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.01665"
			/>
			<path
				d="M26.3107 13.8597L26.2819 13.783L23.3785 6.20936C23.3197 6.06065 23.2151 5.9345 23.0799 5.84916C22.979 5.78457 22.8644 5.74452 22.7452 5.73221C22.626 5.7199 22.5056 5.73568 22.3937 5.77829C22.2817 5.82089 22.1813 5.88914 22.1004 5.97755C22.0196 6.06597 21.9606 6.1721 21.9281 6.28743L19.9683 12.2875H12.0317L10.0718 6.28743C10.0391 6.17227 9.97998 6.06634 9.89909 5.9781C9.8182 5.88985 9.71782 5.82172 9.60593 5.77915C9.49405 5.73658 9.37377 5.72074 9.25468 5.7329C9.13559 5.74505 9.02099 5.78487 8.92002 5.84916C8.78479 5.9345 8.68022 6.06065 8.62145 6.20936L5.71935 13.7844L5.68922 13.8597C5.2714 14.9517 5.21993 16.1499 5.54256 17.2737C5.86519 18.3974 6.54443 19.3858 7.47787 20.0899L7.48882 20.0981L7.51348 20.1173L11.9303 23.4275L14.1216 25.0833L15.4528 26.0899C15.609 26.2079 15.7994 26.2717 15.9952 26.2717C16.1909 26.2717 16.3813 26.2079 16.5375 26.0899L17.8687 25.0833L20.06 23.4275L24.5084 20.0981L24.5207 20.0885C25.4541 19.3847 26.1334 18.3966 26.4563 17.2732C26.7791 16.1497 26.728 14.9517 26.3107 13.8597Z"
				fill="#E24329"
			/>
			<path
				d="M26.3105 13.8598L26.2817 13.7831C24.8671 14.0734 23.5342 14.6729 22.3785 15.5389L16.0032 20.3597L20.0626 23.4275L24.5109 20.0981L24.5232 20.0885C25.4561 19.3844 26.1349 18.3962 26.4573 17.2727C26.7796 16.1492 26.7281 14.9514 26.3105 13.8598Z"
				fill="#FC6D26"
			/>
			<path
				d="M11.9302 23.4277L14.1215 25.0835L15.4527 26.0901C15.6089 26.2081 15.7993 26.2719 15.995 26.2719C16.1908 26.2719 16.3812 26.2081 16.5374 26.0901L17.8686 25.0835L20.0599 23.4277L16.0005 20.3599L11.9302 23.4277Z"
				fill="#FCA326"
			/>
			<path
				d="M9.62123 15.5387C8.46595 14.6732 7.13347 14.0741 5.71935 13.7843L5.68922 13.8596C5.2714 14.9516 5.21993 16.1498 5.54256 17.2736C5.86519 18.3973 6.54443 19.3857 7.47787 20.0898L7.48882 20.098L7.51348 20.1172L11.9303 23.4274L15.9924 20.3596L9.62123 15.5387Z"
				fill="#FC6D26"
			/>
		</svg>
	);
};
